import { debounce } from 'lodash';
import { mapGetters } from 'vuex';
import { nodeAudioSettingsMap } from '../helpers/constants';

import {
  getFieldError,
  getFieldSize,
} from '../helpers/node';

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      settings: {},
    };
  },

  computed: {
    ...mapGetters('callFlows', [
      'nodeErrors'
    ]),

    propertyErrors() {
      return this.nodeErrors[this.node.id]?.propertyErrors;
    },

    generalErrors() {
      return this.nodeErrors[this.node.id]?.errors;
    },

    hasErrors() {
      return (this.generalErrors && this.generalErrors?.length) || (this.propertyErrors && this.propertyErrors?.length);
    },
  },

  methods: {
    getFieldError,

    getFieldSize,

    checkAudioSetting() {
      // Get this node's audio parent setting based on the map in nodeAudioSettingsMap helper const
      const audioParentSetting = nodeAudioSettingsMap.get(this.node.nodeTypeId);

      try {
        if (this.settings[audioParentSetting] && !this.settings[audioParentSetting].isEnabled) {
          this.settings[audioParentSetting].say.text = '';
          this.settings[audioParentSetting].play.URL = '';

        }
      } catch (error) {
        console.error(error);
      }

    },

    inputChange: debounce(function inputChange() {
      this.settings = {
        ...this.settings
      };

      this.$emit('update:node', {
        ...this.node,
        settings: this.settings
      });
    }, 500),

    updateNodeParent() {
      this.settings = {
        ...this.settings
      };
      
      this.checkAudioSetting();

      this.$emit('update:node', {
        ...this.node,
        settings: this.settings
      });
    },

    handleAudioSettingsUpdate(settings) {
      this.settings = {
        ...settings
      };

      this.updateNodeParent();
    },
  },
};